import { ReactNode } from 'react';

import { EntitySidecar } from '@/services/api/generated/partiesService';

import { ApproveFieldButton } from './ApproveFieldButton';

interface FieldWithApprovalProps {
  label: string;
  value: ReactNode;
  fieldKey: string;
  approvalMetadata?: EntitySidecar | null;
  onApprove?: (fieldKey: string) => void;
  showApproveButton?: boolean;
}

export const FieldWithApproval = ({
  label,
  value,
  fieldKey,
  approvalMetadata,
  onApprove,
  showApproveButton = false,
}: FieldWithApprovalProps) => {
  const isAccepted = approvalMetadata?.field_suggestions?.some(
    (fs) => fs.field_key === fieldKey,
  );

  const hasValue = value !== null && value !== undefined && value !== '';

  if (!hasValue) return null;

  return (
    <div className="flex items-start justify-between gap-2">
      <div className="min-w-0 flex-1">
        <dt className="text-sm font-medium text-gray-500">{label}</dt>
        <dd
          className={`mt-1 text-sm ${
            isAccepted ? 'text-gray-900 font-medium' : 'text-gray-700'
          }`}
        >
          {value}
        </dd>
      </div>
      {showApproveButton && onApprove && !isAccepted && (
        <div className="flex-shrink-0">
          <ApproveFieldButton
            fieldKey={fieldKey}
            approvalMetadata={approvalMetadata}
            onApprove={onApprove}
          />
        </div>
      )}
    </div>
  );
};
